import { render, staticRenderFns } from "./print_claims.vue?vue&type=template&id=d6f877bc"
import script from "./print_claims.vue?vue&type=script&lang=js"
export * from "./print_claims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports